export default "__VITE_ASSET__Bp56iGaU__"